"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const library_reactAria_FocusRing = require("../../../library/react-aria/FocusRing.js");
const skipLink = "_skipLink_m150f_1";
const skipLink__text = "_skipLink__text_m150f_27";
const styles = {
  skipLink,
  skipLink__text
};
const SkipLink = ({ children, targetId, className, ...props }) => {
  return /* @__PURE__ */ jsxRuntime.jsx(library_reactAria_FocusRing.FocusRing, { children: /* @__PURE__ */ jsxRuntime.jsx(
    "a",
    {
      href: `#${targetId.replace("#", "")}`,
      className: clsx.clsx(styles.skipLink, className),
      ...props,
      children: /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.Text, { component: "span", className: styles.skipLink__text, children })
    }
  ) });
};
exports.SkipLink = SkipLink;
